
<div class="newletter_area overlay p-5">
    <div class="container">
        <div class="row justify-content-center align-items-center">
            <div class="col-lg-12">
                <div class="row align-items-center">
                    <div class="col-lg-4 align-middle"> 
                        <div class="mb-4">
                        <h3>Why Book With Us</h3>   
                        <small>Charter Smarter</small>
                        <p>We share our passion for travel and yet, through experience, creativity and commitment. We are your Best Way To Get Around Indonesia.</p>
                        </div>
                    </div>
                    <div class="col-lg-4 align-middle"> 
                        <div class="card mb-4">
                            <div class="card-body">
                                <div class="gbr">
                                    <img src="{{ gbr_a }}" alt="">
                                </div>                
                                <h3>Largest Choice of Boats</h3> 
                                <p> East Indonesia Trip offers a selection of up to 100 boat, ranging from Deluxe class to VVIP.</p>
                            </div>
                        </div>

                        <div class="card mb-4">
                            <div class="card-body">
                                <div class="gbr">
                                    <img src="{{ gbr_b }}" alt="">
                                </div>      
                                <h3>Best Destination</h3>
                                <p>The best East Indonesian travel destination for an unforgettable experience!</p> 
                            </div>
                        </div>

                       
                    </div>
                    <div class="col-lg-4 align-middle"> 
                        <div class="card mb-4">
                            <div class="card-body">
                                <div class="gbr">
                                    <img src="{{ gbr_c }}" alt="">
                                </div>  
                                <h3>Competitive Price</h3>
                                <p>The best price for your best experience when traveling with East Indonesia Trip</p> 
                            </div>
                        </div>

                        <div class="card mb-4">
                            <div class="card-body">
                                <div class="gbr">
                                    <img src="{{ gbr_d }}" alt="">
                                </div>  
                                <h3>Best Guides & Documentation Team</h3>
                                <p>Documentation is the most important part of an adventure, and we'll do our best to preserve your memories.</p> 
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>